import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, baseVariables } from '../../../styles';
import { StyledPopupMainProps } from '../Modal.types';

export const StyledPopupMain = styled.div<StyledPopupMainProps>`
  ${(props: StyledPopupMainProps) =>
    props.flexLayout &&
    `
    overflow-y: auto;
    max-height: none !important;
    height: auto !important;
    padding: ${toRem(24)} 0 0 0;
    
    @media only ${baseVariables.mediaQuery.md} {
      padding: ${toRem(32)};
      padding-right: ${toRem(16)};
    }
  `}
  ${rtl`
  font-weight: ${baseVariables.font['fontWeightRegular']};
  &.hqv-modal-content {
    &.custom-scrollbar::-webkit-scrollbar-thumb:hover{
      background-clip: padding-box;     
    }
    &::-webkit-scrollbar-track {
      margin-bottom: ${toRem(88)} !important;
      background-color: transparent;     
    }
    &.hqv-modal-data {
      visibility: hidden;
      display: none;
      ${(props: StyledPopupMainProps) =>
        props.flexLayout &&
        `
      padding: ${toRem(16)} 0 !important;
      .aem-container{
        padding-right: 0 !important;
        padding-left: 0 !important;
      }
    `}
    @media only ${baseVariables.mediaQuery.md} {
      ${(props: StyledPopupMainProps) =>
        props.flexLayout &&
        `
        padding: ${toRem(24)} !important;
        padding-right: ${toRem(12)} !important;
      `}
    }
    @media only ${baseVariables.mediaQuery.lg} {
      ${(props: StyledPopupMainProps) =>
        props.flexLayout &&
        `
        padding: ${toRem(32)} !important;
        padding-right: ${toRem(16)} !important;
      `}
    }
    }
    &.modal-content-loader {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      @media ${baseVariables.mediaQuery.lg} {
        height: ${toRem(250)};
        min-height: ${toRem(250)};
        max-height: ${toRem(250)};
      }
      @media only ${baseVariables.mediaQuery.md} {
        height: ${toRem(200)};
        min-height: ${toRem(200)};
        max-height: ${toRem(200)};
      }
    }
    ${(props: StyledPopupMainProps) =>
      !props.flexLayout &&
      `
      min-height:68vh;
      height: 68vh;
      max-height: 68vh;
    `}
    padding-bottom: ${toRem(32)} !important;
    border-radius: 0 0 ${toRem(14)} ${toRem(14)};
    .user-thin-bar, .cmp-container {
      display: none;
    }
    ${(props: StyledPopupMainProps) =>
      !props.flexLayout &&
      `
      padding-left: 0 !important;
      padding-right: 0 !important;
    `}
  }
  .m-checkbox-selection-item input[type='checkbox'] + label {
    border: none;
    background: transparent;
    &:hover {
      background: transparent;
    }
    display:block;
  }
  .m-checkbox-selection-item input[type='checkbox']:checked + label {
    border: none;
    background: transparent;
    &:hover {
      background: transparent;
    }
  }
  @media only ${baseVariables.mediaQuery.md} {
    ${(props: StyledPopupMainProps) =>
      !props.flexLayout &&
      `
      height: 70vh;
      max-height: 70vh;
    `}
    input[type='radio']:focus + label:before {
      outline: none !important;
    }
  }
  @media only ${baseVariables.mediaQuery.lg} {
    height: auto;
  }
  ${(props: StyledPopupMainProps) =>
    !props.flexLayout &&
    `
    height: 60vh;
    max-height: 60vh;
  `}
  @media only ${baseVariables.mediaQuery.sm} {
    ${(props: StyledPopupMainProps) =>
      !props.flexLayout &&
      `
      height: 63vh;
      max-height: 63vh;
    `}
  }
  `}
`;
